import React from 'react'
import MenuItem from '@mui/material/MenuItem'
import { Select } from '@workwave-tidal/core/components'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'
import FormHelperText from '@mui/material/FormHelperText'
import { DensityType } from '@user/components/Opportunities/AddOpportunityPage/typings'
import { IReOpenFormModel } from '@user/components/Leads/ReOpenDialog/ReOpenLeadDialog'
import { useFormikContext } from 'formik'
import { SalesTeamUser } from '@user/components/Leads/ReOpenDialog/ReOpenLeadFormNew'
import { getPositionMenuItemStyles } from '@user/utils/usePositionMenuItemStyles'
import { useTheme } from '@mui/material/styles'

type Props = {
  owners: SalesTeamUser[]
}

export function OwnerSelect(props: Props) {
  const { owners } = props
  const tidalThemeActive = useTidalThemeActive()
  const { values, setFieldValue, errors, submitCount } =
    useFormikContext<IReOpenFormModel>()
  const { owner } = values

  const density: DensityType = tidalThemeActive ? 'normal' : 'compact'

  const handleOwnerChange = React.useCallback(
    (value: SalesTeamUser | null) => {
      setFieldValue('owner', value)
    },
    [setFieldValue],
  )

  const showError = Boolean(errors?.owner && submitCount > 0)

  const menuItemStyle = getPositionMenuItemStyles(useTheme())

  return (
    <>
      <Select<SalesTeamUser | null>
        getLabel={(option: SalesTeamUser) => option?.fullName || ''}
        items={owners}
        density={density}
        onChange={handleOwnerChange}
        value={owner || null}
        required={true}
        optionMode={'custom'}
        renderOption={(props, user: SalesTeamUser) => (
          <MenuItem
            {...props}
            sx={{
              ...menuItemStyle.root,
            }}
            key={user.id || ''}
            value={user.id || ''}
            disabled={user.isPosition}
          >
            <span style={{ width: `${(user.level || 0) * 10}px` }}></span>
            {user.fullName}
          </MenuItem>
        )}
        label="Owner"
        error={showError}
        data-test-id="owner-select"
      />

      {showError && (
        <FormHelperText error sx={{ ml: '10px' }}>
          Required
        </FormHelperText>
      )}
    </>
  )
}
